/* eslint-disable no-undef */
import { onMounted } from 'vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { useCurrentUser } from '@/shared/composables/useCurrentUser.js'
import { useDebugger } from '@/shared/composables/useDebugger.js'
import { useFeatureFlags } from '@/shared/composables/useFeatureFlags.js'

export const useCrispChatInitializer = () => {
  const { CRISP_ENABLED } = useFeatureFlags()
  const { isUserLoggedIn } = usePermissionSystem()
  const { currentUser } = useCurrentUser()
  const { $debug } = useDebugger()

  onMounted(() => {
    if (isUserLoggedIn.value && CRISP_ENABLED.value) {
      $crisp.push(['set', 'user:nickname', currentUser.value.name.trim()])
      $crisp.push(['set', 'user:email', currentUser.value.email])
      $crisp.push(['set', 'user:avatar', currentUser.value.avatarUrl])
      $debug('Data has been sent to Crisp chat')
    }
  })
}
